const ca = {
  general: {
  },
  faqs: {
  faq1_q: "¿Qué es SPARK81?",
  faq1_r: "SPARK81 es un <b>espacio de acción arcade</b> donde los equipos se enfrentan a <b>retos físicos y digitales</b> en salas temáticas. Cada sesión es una experiencia llena de adrenalina, puntos y risas. ¡Ideal para venir con amigos, en familia o en equipo!",

  faq2_q: "¿Cómo funciona SPARK81?",
  faq2_r: "Jugaréis en <b>equipos de 2 a 6 personas</b> por turnos de <b>20 minutos en distintas salas</b>. En cada una os enfrentaréis a <b>retos colaborativos y competitivos</b> donde superaréis niveles y acumularéis puntos para escalar en el ranking.",

  faq3_q: "¿Cuánto dura SPARK81?",
  faq3_r: "Tu reserva incluye <b>20 minutos de juego en cada sala</b>. <b>Hay que llegar con 15 minutos de antelación</b> para el registro y briefing inicial. Así aprovecharás al máximo tu experiencia.",

  faq4_q: "¿Pueden venir grupos grandes?",
  faq4_r: "Sí. Aunque cada sala se juega en <b>equipos de 2 a 6 personas</b>, podemos organizar la experiencia para <b>grupos más grandes</b>. Os dividiremos en equipos y jugaréis por turnos. Si sois muchos, contactad con nosotros para gestionar la reserva.",

  faq5_q: "¿Cuál es la edad mínima para participar?",
  faq5_r: "La experiencia está <b>diseñada para mayores de 9 años</b>, pero todos los jugadores son bienvenidos. Los menores de 9 deben jugar con al menos <b>un adulto en el equipo</b>. Entre los 9 y 14 años, <b>un adulto debe estar presente en el local</b> durante la sesión.",

  faq6_q: "¿Qué tipo de ropa y calzado debo llevar?",
  faq6_r: "SPARK81 implica actividad física, por lo que es obligatorio venir con <b>ropa cómoda y calzado deportivo cerrado</b>. Por seguridad, el acceso a las salas puede ser denegado si la indumentaria no es adecuada.",

  faq7_q: "¿Puedo volver a jugar a SPARK81 si ya he participado una vez?",
  faq7_r: "¡Claro! En una sola sesión solo descubres <b>una parte del contenido</b>. Cada sala tiene <b>múltiples retos y niveles</b>, así que siempre hay nuevos desafíos. Además, puedes mejorar tu puntuación y <b>subir en el ranking</b>.",

  faq8_q: "¿Puedo cancelar o modificar mi reserva?",
  faq8_r: "Puedes <b>modificar tu reserva</b> si lo haces con al menos <b>48 horas de antelación</b>. Las cancelaciones no son reembolsables. Escríbenos por email o llámanos para gestionar cualquier cambio.",

  faq9_q: "¿Qué pasa si llego tarde?",
  faq9_r: "Si llegas tarde, <b>tu tiempo de juego se reducirá</b>, ya que las sesiones no se pueden retrasar. Para no perder minutos, <b>es imprescindible llegar 15 minutos antes</b> de la hora reservada.",

  faq10_q: "¿Puedo participar si tengo una patología preexistente?",
  faq10_r: "SPARK81 es una experiencia activa que puede incluir <b>correr, saltar, trepar, gatear y lanzar objetos</b>, además de <b>luces intermitentes, música alta y sonidos intensos</b>. Si tienes alguna condición médica, te recomendamos <b>consultarlo con tu profesional de salud antes de participar</b>.",
},
}

module.exports = {
  ca
}
